import React from 'react';
import { Track } from 'livekit-client';
import { useTrackToggle } from '@livekit/components-react';
import { useGlobalSFX } from '@/context/sfx-context/use-sfx.ts';
import { usePushToTalk } from '@/hooks/use-push-to-talk.ts';

export function KeyboardShortcuts() {
  const sfx = useGlobalSFX();

  const microphoneOnChange = React.useCallback(
    (enabled: boolean, userInitiated: boolean) => {
      // TODO: think about sounds when connecting to call -> dublicating toggles (because mic enables by default on call)
      !enabled && sfx.microphoneMute.play();
       enabled && sfx.microphoneUnmute.play();
    },
    [sfx]
  );

  const { toggle: toggleMic, enabled: micEnabled } = useTrackToggle({
    source: Track.Source.Microphone,
    onChange: microphoneOnChange,
  });

  const { toggle: toggleCamera } = useTrackToggle({
    source: Track.Source.Camera,
  });

  const toggleMicSafe = React.useCallback(
    async (enabled?: boolean) => {
      await toggleMic(enabled);
    },
    [toggleMic]
  );

  usePushToTalk(toggleMicSafe, micEnabled);

  React.useEffect(() => {
    function handleShortcut(event: KeyboardEvent) {
      if (toggleMic && event.key === 'M' && (event.ctrlKey || event.metaKey)) {
        // Toggle microphone: Cmd/Ctrl-Shift-M
        event.preventDefault();
        toggleMic();
      }

      if (event.key === 'C' && (event.ctrlKey || event.metaKey)) {
        // Toggle camera: Cmd/Ctrl-Shift-C
        event.preventDefault();
        sfx.cameraToggle.play();
        toggleCamera();
      }

      if (event.key === 'O' && (event.ctrlKey || event.metaKey)) {
        // Toggle global audio: Cmd/Ctrl-Shift-O
        event.preventDefault();
        sfx.microphoneMuteUnmute.play();
      }
    }

    window.addEventListener('keydown', handleShortcut);

    if (window.ipcRenderer) {
      window.ipcRenderer.on(
        'shortcut',
        (_event: any, { action }: { action: string }) => {
          if (action === 'toggleMic' && toggleMic) {
            toggleMic();
          }
          if (action === 'toggleCamera' && toggleCamera) {
            toggleCamera();
          }
          if (action === 'toggleSound') {
            sfx.microphoneMuteUnmute.play();
          }
        }
      );
    }

    return () => {
      window.removeEventListener('keydown', handleShortcut);
      if (window.ipcRenderer) {
        window.ipcRenderer.removeAllListeners('shortcut');
      }
    };
  }, [toggleMic, toggleCamera]);

  return null;
}
